/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-inventory-type.reducer';

export const DiagLabInventoryTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabInventoryTypeEntity = useAppSelector(state => state.diagLabInventoryType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabInventoryTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.detail.title">DiagLabInventoryType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.name">Name</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.description">Description</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.description}</dd>
          <dt>
            <span id="displayKey">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.displayKey">Display Key</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.displayKey}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryTypeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryType.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabInventoryTypeEntity.diagLab ? diagLabInventoryTypeEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-inventory-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-inventory-type/${diagLabInventoryTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabInventoryTypeDetail;
